// extracted by mini-css-extract-plugin
module.exports = {"discordlink":"styles--discordlink--oYzR5","buttonsholder":"styles--buttonsholder--tIRs7","titlescontain":"styles--titlescontain--AAYgG"};